import { ToursPage } from "@/pages/Catalog";
export default ToursPage;
